// The Broadcast Channel API allows basic communication between browsing contexts (that is, windows, tabs, frames, or iframes) and workers on the same origin.
import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { FormStatusMessage } from '../types/broadcast';

const FORM_SYNC_CHANNEL = 'form-sync-channel';

@Injectable({ providedIn: 'root' })
export class BroadcastService implements OnDestroy {
    private channel = new BroadcastChannel(FORM_SYNC_CHANNEL);
    private messageSubject = new Subject<FormStatusMessage>();

    public message$ = this.messageSubject.asObservable();

    public constructor(private readonly ngZone: NgZone) {
        // Using Angular's zone to ensure change detection triggers properly,
        // since BroadcastChannel events execute outside Angular's NgZone by default.
        this.channel.onmessage = (event: MessageEvent): void => {
            this.ngZone.run(() => {
                this.messageSubject.next(event.data);
            });
        };
    }

    public sendMessage(message: FormStatusMessage): void {
        this.channel.postMessage(message);
    }

    public ngOnDestroy(): void {
        this.channel.close();
    }
}
